import React, { useEffect, useState } from "react";
import "./Navbar.css";
import SurveyForm2 from "../surveyform2/survey_form_2";
import { DynamicIcon } from "lucide-react/dynamic";

function Navbar({ navbarConfig }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showSurvey, setShowSurvey] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const backgroundStyle = getBackground(navbarConfig.bg_color);

  const handleExtraBtnClick = (e) => {
    if (!navbarConfig.extraBtn.path || navbarConfig.extraBtn.path === "/") {
      e.preventDefault();
      setShowSurvey(true);
    }
  };

  const handleCloseSurvey = () => setShowSurvey(false);

  const getLucideIcon = (iconName, size = 20) => {
    if (!iconName) return null;
    return <DynamicIcon name={iconName} size={size} />;
  };

  return (
    <>
      <nav
        className={`navbar ${isScrolled ? "navbar-scrolled" : ""}`}
        style={{ background: isScrolled ? "transparent" : backgroundStyle }}
      >
        {/* Logo */}
        <div className="navbar-logo">
          {navbarConfig.logo && (
            <img
              src={navbarConfig.logo}
              alt="Logo"
              className="navbar-logo-img"
            />
          )}
          <span className="navbar-logo-text">{navbarConfig.logo_name}</span>
        </div>

        {/* Hamburger */}
        <div
          className={`hamburger ${isMenuOpen ? "open" : ""}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Nav Links + CTA */}
        <div className={`navbar-actions ${isMenuOpen ? "active" : ""}`}>
          <ul
            className={`navbar-links ${
              navbarConfig.backgroundShape === "round-circle"
                ? isScrolled
                  ? "navbar-links-rounded"
                  : "navbar-links-rounded navbar-links-shrinked"
                : ""
            }`}
          >
            {navbarConfig.items.map((item, index) => (
              <li
                key={index}
                className={`nav-item ${
                  window.location.pathname === item.path ? "active" : ""
                }`}
              >
                <a href={item.path} className="nav-item-link">
                  {item.icon && (
                    <span className="nav-item-icon">
                      {getLucideIcon(item.icon)}
                    </span>
                  )}
                  {(!isScrolled || isMenuOpen) && (
                    <span className="nav-item-text">{item.name}</span>
                  )}
                </a>
              </li>
            ))}
          </ul>

          <a
            href={navbarConfig.extraBtn.path || "#"}
            className="navbar-cta"
            onClick={handleExtraBtnClick}
          >
            {getLucideIcon(navbarConfig.extraBtn.icon, 20)}
            {navbarConfig.extraBtn.name}
          </a>
        </div>
      </nav>

      {/* Survey Modal */}
      {showSurvey && (
        <div className="modal-overlay" onClick={handleCloseSurvey}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={handleCloseSurvey}>
              ✖
            </button>
            <SurveyForm2 />
          </div>
        </div>
      )}
    </>
  );
}

// Helper: gradient background
function getBackground(bgColors) {
  if (!bgColors || bgColors.length === 0) return "#333";
  return bgColors.length === 1
    ? bgColors[0]
    : `linear-gradient(90deg, ${bgColors.join(", ")})`;
}

export default Navbar;
